import Editor from "src/components/TextEditor";

interface SimpleEditorProps {
	onSubmit: (html: string) => void;
	clearAfterSave?: boolean;
	isLoading?: boolean;
	placeholder?: string;
	submitText?: string;
	cancelText?: string;
	initialHtml?: string;
	onCancel?: () => void;
}

export const SimpleEditor = ({
	onSubmit,
	clearAfterSave,
	isLoading,
	placeholder,
	submitText,
	cancelText,
	initialHtml,
	onCancel,
}: SimpleEditorProps) => {
	return (
		// @ts-expect-error Editor is a JS component — will be typed after migration
		<Editor
			onSubmit={onSubmit}
			clearAfterSave={clearAfterSave}
			isLoading={isLoading}
			placeholder={placeholder}
			submitText={submitText}
			cancelText={cancelText}
			initialHtml={initialHtml}
			onCancel={onCancel}
		/>
	);
};
